import React, { useEffect, useState } from 'react';
import { Modal, Tag, Typography, message } from 'antd';
import { WarehouseMarkItem, getWarehouseMarks, getWarehouseDataMatrixSvg } from '../../api/warehouse';
import DataMatrixImage from '../marking/DataMatrixImage';
import { num } from './format';

const { Text } = Typography;

interface Props {
  itemId: string;
}

// Rev. 24 (warehouse_liquids.md): инлайн-развёртка строки фасовки — марки,
// лежащие на складе (ready + reserved); клик по марке — модалка с графическим
// Data Matrix.
const PackageMarks: React.FC<Props> = ({ itemId }) => {
  const [marks, setMarks] = useState<WarehouseMarkItem[] | null>(null);
  const [selected, setSelected] = useState<WarehouseMarkItem | null>(null);

  useEffect(() => {
    let cancelled = false;
    getWarehouseMarks({ item_id: itemId })
      .then(m => { if (!cancelled) setMarks(m); })
      .catch(() => {
        if (!cancelled) {
          message.error('Не удалось загрузить марки');
          setMarks([]);
        }
      });
    return () => { cancelled = true; };
  }, [itemId]);

  return (
    <div style={{ padding: '4px 0 4px 24px' }}>
      {marks == null ? (
        <Text type="secondary" style={{ fontSize: 12 }}>Загрузка марок…</Text>
      ) : marks.length === 0 ? (
        <Text type="secondary" style={{ fontSize: 12 }}>Марок на складе нет</Text>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {marks.map(m => (
            <div
              key={m.marking_code}
              style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}
            >
              <span
                style={{ fontSize: 12, wordBreak: 'break-all', cursor: 'pointer', textDecoration: 'underline' }}
                title="Показать графическую марку"
                onClick={e => { e.stopPropagation(); setSelected(m); }}
              >
                {m.marking_code}
              </span>
              {m.status === 'reserved' && <Tag color="orange">в резерве</Tag>}
              {m.product_type === 'bulk' && m.bulk_remaining_volume != null && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  остаток {num(m.bulk_remaining_volume)} л{m.total_volume != null ? ` из ${num(m.total_volume)} л` : ''}
                </Text>
              )}
            </div>
          ))}
        </div>
      )}
      <Modal
        open={selected != null}
        onCancel={() => setSelected(null)}
        footer={null}
        centered
        width={360}
      >
        {selected && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 16 }}>
            {selected.raw_code ? (
              <>
                <DataMatrixImage code={selected.raw_code} scale={2} fetcher={getWarehouseDataMatrixSvg} />
                <div style={{ marginTop: 12, wordBreak: 'break-all', fontSize: 12, userSelect: 'text' }}>
                  {selected.marking_code}
                </div>
              </>
            ) : (
              <div style={{ padding: 20, textAlign: 'center', color: '#ff4d4f' }}>
                Полный код марки не найден.
                <br />
                DataMatrix нельзя сгенерировать по обрезанному marking_code.
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PackageMarks;
